/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react'

export const JourneyContext = createContext({} as any)
